import { CompanyDefaultStatementWarningType } from "./company-default-statement-warnings";
import type { UpsertCompanyQuestionTemplateCompetency } from "@/types/company-manage";
import { buildTestId } from "@/utils/helpers";

export const DUPLICATE_NAME_MESSAGE = "A company with this name already exists";

export const DEFAULT_WRITTEN_COMPETENCY = {
  definition:
    "Company-level default written assessment questions copied to new screeners.",
  displayName: "Default written assessment",
  hasCustomScoringGuidelines: false,
  isCustom: true,
  isIncluded: true,
  name: "company_default_written_assessment",
  scoringGuidelines: null,
  warningBypassLog: null,
} satisfies Omit<
  UpsertCompanyQuestionTemplateCompetency,
  "assessmentQuestions"
>;

export const NOTIFICATION_MESSAGES = {
  updateError: "Failed to update company defaults. Please try again.",
  updateSuccess: "Company defaults updated",
} as const;

export const EDIT_COMPANY_MODAL_TEST_IDS = {
  addBasicQuestionButton: buildTestId(
    "company-management",
    "edit-company-modal",
    "add-basic-question-button",
  ),
  addWrittenQuestionButton: buildTestId(
    "company-management",
    "edit-company-modal",
    "add-written-question-button",
  ),
  basicQuestionsTable: buildTestId(
    "company-management",
    "edit-company-modal",
    "basic-questions-table",
  ),
  cancelButton: buildTestId(
    "company-management",
    "edit-company-modal",
    "cancel-button",
  ),
  closeButton: buildTestId(
    "company-management",
    "edit-company-modal",
    "close-button",
  ),
  defaultsLoadError: buildTestId(
    "company-management",
    "edit-company-modal",
    "defaults-load-error",
  ),
  conclusionInput: buildTestId(
    "company-management",
    "edit-company-modal",
    "default-conclusion-input",
  ),
  conclusionTemplatingWarning: buildTestId(
    "company-management",
    "edit-company-modal",
    "conclusion-templating-warning",
  ),
  introInput: buildTestId(
    "company-management",
    "edit-company-modal",
    "default-intro-input",
  ),
  introInvalidBracesWarning: buildTestId(
    "company-management",
    "edit-company-modal",
    "intro-invalid-braces-warning",
  ),
  introUnrecognizedVariablesWarning: buildTestId(
    "company-management",
    "edit-company-modal",
    "intro-unrecognized-variables-warning",
  ),
  nameInput: buildTestId("company-management", "edit-company-modal", "name"),
  questionEditorInput: buildTestId(
    "company-management",
    "edit-company-modal",
    "question-editor-input",
  ),
  questionEditorSaveButton: buildTestId(
    "company-management",
    "edit-company-modal",
    "question-editor-save-button",
  ),
  saveButton: buildTestId(
    "company-management",
    "edit-company-modal",
    "save-button",
  ),
  writtenQuestionsTable: buildTestId(
    "company-management",
    "edit-company-modal",
    "written-questions-table",
  ),
};

export const EDIT_COMPANY_MODAL_OVERLAY_CLASS =
  "company-management-edit-company-modal-overlay";

export const WARNING_TEST_ID_BY_TYPE = {
  [CompanyDefaultStatementWarningType.ConclusionTemplating]:
    EDIT_COMPANY_MODAL_TEST_IDS.conclusionTemplatingWarning,
  [CompanyDefaultStatementWarningType.IntroInvalidBraces]:
    EDIT_COMPANY_MODAL_TEST_IDS.introInvalidBracesWarning,
  [CompanyDefaultStatementWarningType.IntroUnrecognizedVariables]:
    EDIT_COMPANY_MODAL_TEST_IDS.introUnrecognizedVariablesWarning,
} as const;

export const INPUT_CLASS_NAMES = {
  input:
    "border-uw-gray-3 rounded-[4px] text-sm leading-5 text-uw-gray-9 focus:border-uw-purple-3",
};

export const FIELD_IDS = {
  defaultClosingStatement: "company-default-closing-statement",
  defaultOpeningStatement: "company-default-opening-statement",
} as const;

export const COMPANY_TEMPLATE_SAMPLE_JOB_TITLE = "Sample Job Title";
